import fetcher from 'api/fetcher';
import { NotificationName } from 'utils/constants/notification';

import urlParser from 'bloko/common/urlParser';

import { addNotification } from 'store/models/notification';

export default (key, value) => {
    return (dispatch) => {
        const params = {
            key,
            value,
        };
        const queryStr = urlParser.stringify(params);
        return fetcher.put(`/api/v1/admin/translations?${queryStr}`).then(() => {
            dispatch(addNotification(NotificationName.TranslationsSaveSuccess));
        });
    };
};
